import {StateMachineConfig} from '../fsm/stateMachineTypes';
import {InitState} from './regular/InitState';

export const coreStateMachineConfig: StateMachineConfig = {
    entryStateId: InitState,
    statesList: [
        {state: InitState, transitions: []}
    ]
};